import { boticarioTheme, quemDisseBereniceTheme } from '@grupoboticario/flora'
import { Box } from '@grupoboticario/flora-react-box'
import { FloraProvider } from '@grupoboticario/flora-react-flora-provider'
import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const theme =
  process.env.REACT_APP_UN === 'QDB' ? quemDisseBereniceTheme : boticarioTheme

ReactDOM.render(
  <FloraProvider>
    <Box className={theme}>
      <App />
    </Box>
  </FloraProvider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
